import ICAL from 'ical.js';
import moment from 'moment';

const endpoint = '/public/basic.ics?futureevents=true';

export class GoogleCalendar {
  constructor () {
    this.events = [];
    this.eventsPassed = [];
    this.eventsUpcoming = [];
    this.eventsPerDay = {};
  }

  load () {
    return new Promise((resolve, reject) => {
      window.fetch(endpoint).then(response => response.text()).then(data => {
        var jcalData = ICAL.parse(data);
        var vcalendar = new ICAL.Component(jcalData);
        var vevents = vcalendar.getAllSubcomponents('vevent');
        this.events = vevents.map((vevent, index) => {
          return {
            id: index,
            summary: vevent.getFirstPropertyValue('summary'),
            start: moment(vevent.getFirstPropertyValue('dtstart').toString()),
            end: moment(vevent.getFirstPropertyValue('dtend').toString()),
          };
        }).sort((a,b) => a.start.unix() - b.start.unix())

        // Remove private events
        this.events = this.events.filter(event => event.summary.toLowerCase() !== 'busy');

      
        this.events.forEach(event => {
          event.hour = parseInt(event.start.format('HH'));
          var day = event.start.format('YYYY-DD-MM');
          if (!this.eventsPerDay[day]) this.eventsPerDay[day] = [];
          this.eventsPerDay[day].push(event);
        });

        resolve();
      }).catch(reject);
    })
  }

  filter () {
    const now = moment();
    this.eventsPassed = this.events.filter(event => event.end.isBefore(now));
    this.eventsUpcoming = this.events.filter(event => event.end.isAfter(now));
  }

  get agenda () {
    var day = moment();
    var calendar = [];

    for (var i = 0; i < 14; i++) {
      var dayString = day.format('YYYY-DD-MM');
      calendar.push({
        dayString,
        day: moment(day),
        events: this.eventsPerDay[dayString] || []
      });
      day.add(1, 'day');
    }

    return calendar;
  }

}
